<template>
  <div
    class="shifts"
    :data-shift-items-length="newItems.length"
  >
    <div class="shifts__list-view">
      <header class="ws-list-view__header">
        <div
          class="ws-list-view__header-item"
          v-for="column in columns"
          :key="column.field"
        >
          <span class="ws-list-view__header-label">
            <strong v-text="column.label"></strong>
          </span>
        </div>
      </header>
      <div
        class="shifts__item"
        v-for="shift in newItems"
        :key="shift.guid"
      >
        <ws-list-view
          class="is-table is-small"
          :bordered="true"
          :header="false"
          :detailed="false"
          :columns="columns"
          :data="shift.groups"
        >
          <ws-exams-shifts-list-item
            slot-scope="props"
            :props="props"
                        :curators='curators[exam.de_center.parent.guid]'
            :shift="shift"
            :exam="exam"
            @shift-update="shiftItemUpdate"
          />
          <template
            slot="header"
            slot-scope="props"
          >
            <strong>{{ props.column.label }}</strong>
          </template>
        </ws-list-view>
      </div>
    </div>
    <footer class="shifts__footer columns">
      <div class="column is-6 is-vcentered">
        <div class="buttons">
          <ws-role-node :except="['front_rcc', 'front_university', 'front_dep']">
            <button
              class="ws-button button is-text"
              :disabled="exam.status === constants.request_exams_status.AGREED_DE_DEPARTMENT"
              @click="addGroupsToItem()"
            >
              <ws-icon
                class="ws-button__icon is-position-left"
                name="plus-circle"
                :title="$t('Добавить экзаменационную группу')"
                color="#1c3b8d"
                width="20"
                height="20"
              />
              <strong
                class="ws-button__text has-text-primary"
                v-text="$t('Добавить экзаменационную группу')"
              ></strong>
            </button>
          </ws-role-node>
          <ws-role-node :only="['front_dep', 'front_rcc', 'front_university']">
            <button
              v-if="exam.status !== constants.request_exams_status.REVIEW_DE_DEPARTMENT && exam.status !== constants.request_exams_status.AGREED_DE_DEPARTMENT"
              class="ws-button button is-text"
              @click="addGroupsToItem()"
            >
              <ws-icon
                class="ws-button__icon is-position-left"
                name="plus-circle"
                :title="$t('Добавить экзаменационную группу')"
                color="#1c3b8d"
                width="20"
                height="20"
              />
              <strong
                class="ws-button__text has-text-primary"
                v-text="$t('Добавить экзаменационную группу')"
              ></strong>
            </button>
          </ws-role-node>
        </div>
      </div>
      <div class="column is-6 is-vcentered">
        <div class="buttons has-text-right-desktop buttons-half-width is-right buttons-horizontal">

          <ws-role-node :only="['front_dep', 'front_admin', 'front_rcc']">
            <div
              class="field has-addons"
              v-if="exam.status === constants.request_exams_status.REVIEW_DE_DEPARTMENT"
            >
              <ws-role-node :only="['front_rcc']">
                <div class="control">
                  <button
                    class="ws-button button is-large is-primary is-outlined is-horizontal-marginless"
                    @click="updateExamStatus('revision_de_department')"
                  >
                    <span
                      class="is-size-4 has-text-weight-bold"
                      v-text="$t('На доработку в РО')"
                    ></span>
                  </button>
                </div>
              </ws-role-node>
            </div>

            <div
              class="field has-addons"
              v-if="exam.status === constants.request_exams_status.AGREED_DE_DEPARTMENT
              || exam.status === constants.request_exams_status.REVIEW_DE_DEPARTMENT"
            >
              <ws-role-node :only="['front_dep', 'front_admin']">
                <div class="control">
                  <button
                    class="ws-button button is-large is-primary is-outlined is-horizontal-marginless"
                    @click="updateExamStatus('revision_de_department')"
                  >
                    <span
                      class="is-size-4 has-text-weight-bold"
                      v-text="$t('На доработку в РО')"
                    ></span>
                  </button>
                </div>
              </ws-role-node>

              <ws-role-node :only="['front_dep', 'front_admin']">
                <div class="control">
                  <button
                    class="ws-button button is-large is-primary is-outlined is-horizontal-marginless"
                    :disabled="currentRole === 'front_rcc'"
                    :enabled="exam.creator_id"
                    @click="updateExamStatusWithReason('revision_de_department', true)"
                  >
                    <span
                      class="is-size-4 has-text-weight-bold"
                      v-text="$t('На доработку в РО (+ тикет)')"
                    ></span>
                  </button>
                </div>
              </ws-role-node>
            </div>
          </ws-role-node>
          <ws-role-node :only="['front_rcc', 'front_admin', 'front_curator']">
            <div
              class="field has-addons"
              v-if="exam.status === constants.request_exams_status.REVISION_DE_DEPARTMENT
              || exam.status === constants.request_exams_status.REVIEW_AUTH_ORG"
            >
              <ws-role-node :only="['front_rcc', 'front_admin']
              ">
                <div class="control">
                  <button
                    class="ws-button button is-large is-primary is-outlined is-horizontal-marginless"
                    @click="updateExamStatus('revision_auth_org')"
                  >
                    <span
                      class="is-size-4 has-text-weight-bold"
                      v-text="$t('На доработку в ОО')"
                    ></span>
                  </button>
                </div>
                <div class="control">
                  <button
                    class="ws-button button is-large is-primary is-outlined is-horizontal-marginless"
                    :enabled="exam.creator_id"
                    @click="updateExamStatusWithReason('revision_auth_org', true)"
                  >
                    <span
                      class="is-size-4 has-text-weight-bold"
                      v-text="$t('На доработку в ОО (+ тикет)')"
                    ></span>
                  </button>
                </div>
              </ws-role-node>
            </div>
            <div
              class="field has-addons"
              v-if="exam.status === constants.request_exams_status.REVIEW_AUTH_ORG"
            >
              <ws-role-node :only="['front_curator']
              ">
                <div class="control">
                  <button
                    class="ws-button button is-large is-primary is-outlined is-horizontal-marginless"
                    @click="updateExamStatus('revision_auth_org')"
                  >
                    <span
                      class="is-size-4 has-text-weight-bold"
                      v-text="$t('На доработку в ОО')"
                    ></span>
                  </button>
                </div>
              </ws-role-node>
            </div>
          </ws-role-node>
          <ws-role-node :only="['front_rcc', 'front_university', 'front_dep', 'front_admin', 'front_curator']">
            <popper
              trigger="hover"
              :stop-propagation="true"
              v-if="exam.status === constants.request_exams_status.REVISION_DE_DEPARTMENT
              || exam.status === constants.request_exams_status.REVIEW_AUTH_ORG ||
              exam.status === constants.request_exams_status.NEW
              || exam.status === constants.request_exams_status.REVISION_AUTH_ORG"
              :prevent-default="true"
              :options="{placement: 'top'}"
            >
              <div class="popper is-warning has-text-left exam-status-hint">
                <b>Для отправки на согласование необходимо:</b>
                <ul>
                  <li
                    v-if="this.isHasCod"
                    class="has-text-success"
                  >
                    <ws-icon
                      name="check-mark"
                      color="#3f842f"
                      width="16"
                      height="16"
                    />
                    <span>{{$t('Наличие КОД')}}</span>
                  </li>
                  <li
                    v-else
                    class="has-text-danger"
                  >
                    <ws-icon
                      name="close"
                      color="#EB5757"
                      width="16"
                      height="16"
                    />
                    <span>{{$t('Наличие КОД')}}</span>
                  </li>
                  <li
                    v-if="this.isHasGroupsInAtLeastOneShift"
                    class="has-text-success"
                  >
                    <ws-icon
                      name="check-mark"
                      color="#3f842f"
                      width="16"
                      height="16"
                    />
                    <span>{{$t('Наличие группы в смене')}}</span>
                  </li>
                  <li
                    v-else
                    class="has-text-danger"
                  >
                    <ws-icon
                      name="close"
                      color="#EB5757"
                      width="16"
                      height="16"
                    />
                    <span>{{$t('Наличие группы в смене')}}</span>
                  </li>
                </ul>
              </div>

              <div
                class="ws-button-wrapper"
                slot="reference"
              >
                <ws-role-node :only="['front_rcc', 'front_admin', exam.status === constants.request_exams_status.REVISION_DE_DEPARTMENT ? 'front_dep' : '' ]">
                  <div class="control">
                    <button
                      class="ws-button button is-large is-primary is-outlined"
                      @click="updateExamStatus('review_de_department')"
                      :disabled="!isCanReview"
                      v-if="exam.status === constants.request_exams_status.REVISION_DE_DEPARTMENT
                        || exam.status === constants.request_exams_status.REVIEW_AUTH_ORG"
                    >
                      <span
                        class="is-size-4 has-text-weight-bold"
                        v-text="$t('Отправить на согласование оператору')"
                      ></span>
                    </button>
                  </div>
                </ws-role-node>
                <ws-role-node :only="['front_admin', 'front_rcc', 'front_curator']">
                  <button
                    class="ws-button button is-large is-primary is-outlined is-popover"
                    :disabled="!isCanReview"
                    v-if="exam.status === constants.request_exams_status.NEW
                      || exam.status === constants.request_exams_status.REVISION_AUTH_ORG"
                    @click="updateExamStatus('review_auth_org')"
                  >
                    <span
                      class="is-size-4 has-text-weight-bold"
                      v-text="$t('Отправить на согласование в РО')"
                    ></span>
                  </button>
                </ws-role-node>
              </div>
            </popper>
          </ws-role-node>
          <ws-role-node :only="['front_dep', 'front_admin']">
            <div
              class="field"
              v-if="exam.status === constants.request_exams_status.REVIEW_DE_DEPARTMENT"
            >
              <ws-role-node :only="['front_dep', 'front_admin']">
                <div class="control">
                  <button
                    class="ws-button button is-large is-primary is-outlined"
                    @click="updateExamStatus('agreed_de_department')"
                  >
                    <span
                      class="is-size-4 has-text-weight-bold"
                      v-text="$t('Согласовать')"
                    ></span>
                  </button>
                </div>
              </ws-role-node>
            </div>
          </ws-role-node>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import WsRequestExamsChooseGroup from '@/components/de/request-exams/modals/WsRequestExamsChooseGroup'
import { constants } from '@/services/constants.service'
import Popper from 'vue-popperjs'

export default {
  name: 'WsExamsShiftsList',
  components: { 'popper': Popper },
  props: {
    exam: Object,
    items: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      newItems: [],
      columns: [
        {
          field: 'complexity_level',
          label: this.$t('№ Смены')
        },
        {
          field: 'title',
          label: this.$t('№ Экз. группы')
        },
        {
          field: 'submitted_at',
          label: this.$t('Образовательная организация')
        },
        {
          field: 'de_center',
          label: this.$t('Учебная группа')
        },
        {
          field: 'count',
          label: this.$t('Сдающих (план)')
        },
        {
          field: 'independent_estimate_participants_number',
          label: this.$t('Сдающих НОК (план)')
        },
        {
          field: 'job_issued_at',
          label: this.$t('Выдача задания')
        },
        {
          field: 'started_at',
          label: this.$t('Дата начала')
        },
        {
          field: 'ended_at',
          label: this.$t('Дата окончания')
        },
        {
          label: ''
        }
      ],
      constants,
      curators: []
    }
  },
  watch: {
    items: {
      immediate: true,
      handler (items) {
        this.newItems = []
        if (items && items.length) {
          let tempArray = [...items]
          tempArray.sort((a, b) => {
            return new Date(a.started_at) - new Date(b.started_at)
          })
          for (let s of tempArray) {
            if (s.groups && s.groups.length) {
              s.groups.sort((a, b) => {
                return a.number - b.number
              })
              this.newItems.push(s)
            }
          }
        }
      }
    }
  },
  computed: {
    ...mapState('exams', {
      isFindPending: 'isFindPending'
    }),
    ...mapState('authentication', ['user', 'currentRole']),
    isCanReview () {
      return (this.isHasCod &&
        this.isHasGroupsInAtLeastOneShift)
    },
    isHasGroupsInAtLeastOneShift () {
      if (this.exam.shifts && this.exam.shifts.length) {
        for (let shift of this.exam.shifts) {
          if (shift.groups && shift.groups.length) {
            return true
          }
        }
      }
      return false
    },
    isHasCod () {
      if (this.exam.accred_comps && this.exam.accred_comps.competency && this.exam.accred_comps.competency.complexity_level && this.exam.accred_comps.competency.complexity_level.length) {
        return this.exam.accred_comps.competency.complexity_level.indexOf(this.exam.accred_comps.complexity_level) > -1
      } else {
        return false
      }
    },
    isStatusReadyForReview () {
      return this.exam.status === 'new' || this.exam.status === 'review_auth_org' || this.exam.status === 'revision_auth_org'
    }
  },
  methods: {
    ...mapActions('exams', ['update']),
    ...mapActions('exams/shifts', {
      createGroup: 'create',
      removeGroup: 'remove'
    }),
    ...mapActions('refbook/curators', {
      'findCurators': 'create'
    }),
    shiftItemUpdate () {
      this.$emit('shifts-updated')
    },
    addGroupsToItem () {
      this.$buefy.modal.open({
        parent: this,
        component: WsRequestExamsChooseGroup,
        hasModalCard: true,
        props: {
          exam: this.exam
        },
        events: {
          'onAddItem': () => {
            this.$emit('shifts-updated')
          }
        },
        canCancel: false
      })
    },

    async updateExamStatusWithReason (status, reason) {
      if (reason) {
        this.$buefy.dialog.prompt({
          title: this.$t('Причина доработки'),
          message: this.$t(`Будет создано обращение в тикет системе от имени автора создания заявки. Автору заявки придёт уведомление с указанием причины отправки заявки на доработку`),
          confirmText: this.$t('Отправить'),
          cancelText: this.$t('Отмена'),
          inputAttrs: {
          },
          trapFocus: true,
          onConfirm: (value) => {
            this.updateExamStatus(status, value)
          }
        })
      }
    },

    async updateExamStatus (status, reason) {
      try {
        await this.update([this.exam.guid, reason ? { reason } : [], `/status/${status}`])
        this.$buefy.toast.open({
          message: this.$t(`Статус заявки «${this.exam.name.display}» успешно изменен.`),
          type: 'is-success'
        })
      } catch (e) {
        this.$buefy.toast.open({
          message: this.$t('Что-то пошло не так. Попробуйте еще раз'),
          type: 'is-danger'
        })
      }
    }
  },
  async mounted () {
    const { guid } = this.exam.de_center.parent
    if (guid && guid !== constants.NULL_GUID) {
      this.curators = await this.findCurators([ [guid], '/list' ])
    }
  }
}
</script>
